<div class="toolTipBody" [ngClass]="[background, position]">
    <ng-container *ngFor="let message of messages">
        <div *ngIf="message.type === 'text'">{{message.content | translate}}</div>
        <div *ngIf="message.type === 'html'" [innerHTML]="message.content | translate"></div>
    </ng-container>
</div>
